/**
* @Author: zachalam
* @Date:   2017-01-13T14:07:06-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-24T11:01:04-08:00
*/

// determine which api to use?
let api = process.env.NODE_ENV == 'development' ? 'http://api-mt.test/api' : '/api';
let per_page = 24;    // number of API results to allow per page
let max_trips = 5;    // max number of trips a user can have.

const MAX_NUMBER_PHOTOS = 8; // Max number of photos
const GOOGLE_API_KEY = 'AIzaSyDqNadF2ywTPSoOYCS6GuOk6evkYdGoSNY';
const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/DateMissTravel",
  twitter: "https://twitter.com/DateMissTravel",
  instagram: "http://instagram.com/DateMissTravel",
  youtube: "https://www.youtube.com/user/DateMissTravel"
}

const SUNSET_DATE = 'Aug 01, 2025';

module.exports = {
  api,
  per_page,
  max_trips,
  MAX_NUMBER_PHOTOS,
  GOOGLE_API_KEY,
  SOCIAL_LINKS,
  SUNSET_DATE
}



// WEBPACK FOOTER //
// ./src/config/Master.js